import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PorIconModule } from '@por/shared/ui/icon-lib';
import { ApxTabGroupComponent } from './tab-group.component';
import { ApxTabComponent } from './tab/tab.component';
import { ApxTabDirective } from './directives/tab.directive';

@NgModule({
    imports: [CommonModule, PortalModule, PorIconModule, ApxTabComponent, ApxTabGroupComponent, ApxTabDirective],
    exports: [ApxTabComponent, ApxTabGroupComponent, ApxTabDirective]
})
export class ApxTabsModule {}

// Re-export components for barrel exports
export { ApxTabGroupComponent } from './tab-group.component';
export { ApxTabComponent } from './tab/tab.component';
export { ApxTabDirective } from './directives/tab.directive';
